import * as React from 'react';
import { Column } from 'react-data-grid';
import UnitEdit from './UnitEdit';
import LocationColumn from 'src/components/LocationRender';
import ClientName from 'src/container/Client/ClientName';
import uuidv1 from 'uuid/v1';
import Container from '../Generic/Container';
import './Unit.scss';

const columns: Array<Column> = [
  {
    key: 'typedId',
    name: 'Code',
    filterable: false,
    editable: false,
    resizable: true,
    sortable: true,
    formatter: ({value}) => <div> {value.split && value.includes(':') ? value.split(':')[1] : null}</div>
  },
  {
    key: 'name',
    name: 'Name',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
  },
  {
    key: 'clientId',
    name: 'Client',
    filterable: true,
    editable: true,
    resizable: true,
    sortable: true,
    formatter: ClientName
  },
  LocationColumn('location', 'Location', 50)
];

function renderEdit({ resolveRow, rejectRow, fromObject, isNew }: any) {
  return (
    <UnitEdit  
      resolveRow={resolveRow}
      rejectRow={rejectRow}
      fromObject={fromObject}
      isNew={isNew}
    />
  );
}

export default Container(
  columns, 
  'units', 
  renderEdit,
  ({isSuperUser}) => ({
    name: 'Units',
    icon: 'microchip',
    enableFilter: isSuperUser,
    enableAddRow: isSuperUser,
    addRowButtonText: 'Add Unit',
    filterRowsButtonText: 'Filter Unit'
  }),
  () => {
    return {
      unitId: 'UnitDetails:',
      typedId: uuidv1()
    };
  },
);


// WEBPACK FOOTER //
// ./src/container/Unit/Unit.tsx